import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from '@react-google-maps/api';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import './style/MapModal.css'

function MapModal({ show, onHide, onSelectLocation }) {
  const mapContainerStyle = {
    width: '100%',
    height: '350px',
  };

  const [markerPosition, setMarkerPosition] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const [address, setAddress] = useState('');
  const [selectedAddress, setSelectedAddress] = useState('');

  const handleMapReset = () => {
    setMarkerPosition(null);
    setSearchText('');
    setSelectedAddress('');
  };

  // Reset map state whenever the modal visibility changes
  useEffect(() => {
    if (show) {
      handleMapReset();
    }
  }, [show]);


  //const mapRef = useRef(null);

  const handleSelectLocation = () => {
    if (markerPosition) {
      onSelectLocation(address);
      onHide();
    }
  };

  const handleMapClick = async (event) => {
    setMarkerPosition(event.latLng.toJSON());

    // Use the Google Maps Geocoding API to get the address from coordinates
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: event.latLng }, async (results, status) => {
      if (status === 'OK' && results[0]) {
        const clickedAddress = results[0].formatted_address;
        const results2 = await geocodeByAddress(clickedAddress);
        const latLng = await getLatLng(results2[0]);
        const resultArray =[clickedAddress,results2,latLng]
        setSelectedAddress(clickedAddress)
        setAddress(resultArray);
        setInfoWindowOpen(true);
        console.log('Address from pointer ',clickedAddress)
      }
    });
  };

  const handleSelect = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      const resultArray =[address,results,latLng]
      setSelectedAddress(address)
      setSearchText(address)
      setAddress(resultArray)
      setMarkerPosition(latLng);
      setInfoWindowOpen(true);
      console.log('Address from autocomplete ',results[0])
    } catch (error) {
      console.error('Error selecting location:', error);
    }
  };
  

  // const getCurrentLocation = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         const currentLocation = { lat: latitude, lng: longitude };

  //         console.log(position)
  
  //         setMarkerPosition(currentLocation);
  //         setAddress('Current Location');
  //         setInfoWindowOpen(true);
  
  //         // Center the map on the user's current location using mapRef
  //         if (mapRef.current) {
  //           mapRef.current.panTo(currentLocation);
  //         }
  //       },
  //       (error) => {
  //         console.error('Error getting current location:', error);
  //       }
  //     );
  //   } else {
  //     console.error('Geolocation is not supported in this browser.');
  //   }
  // }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <PlacesAutocomplete
            value={searchText}
            onChange={setSearchText}
            onSelect={handleSelect}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
              <div>
                <input
                  {...getInputProps({
                    placeholder: 'Search for a location...',
                    className: 'form-control',
                  })}
                />
                <div className="suggestions-container mx-3">
                  {loading ? <div>Loading...</div> : null}
                  {suggestions.map((suggestion) => (
                    <div className='border-1 border py-1 px-1 selection-box'
                     {...getSuggestionItemProps(suggestion)}>
                      {suggestion.description}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
        </Form.Group>
        <div className="map-container">
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={15}
            center={markerPosition || { lat: 3.0736, lng: 101.5874 }}
            onClick={handleMapClick}
            //ref={mapRef}
          >
            {markerPosition && (
              <Marker
                position={markerPosition}
                //onClick={() => setInfoWindowOpen(!infoWindowOpen)}
              />
            )}
            {/* {infoWindowOpen && (
              <InfoWindow
                position={markerPosition}
                onCloseClick={() => setInfoWindowOpen(false)}
              >
                <div>Selected Location</div>
              </InfoWindow>
            )} */}
          </GoogleMap>
        </div>
        <h6 className='mt-2'>Selected Address:</h6>
        {address && <p className='address-txt'>{selectedAddress}</p>}
        <div className='d-flex justify-content-end'>
          <Button  id='confirm-location' onClick={handleSelectLocation}>
          Confirm Location
          </Button>
        </div>
        
        {/* <Button variant="primary" onClick={getCurrentLocation}>
          Get Current Location
        </Button> */}
      </Modal.Body>
    </Modal>
  );
}

export default MapModal;
